import GradientLegend from '../charts/legend/GradientLegend';
import EventLegend from '../charts/legend/EventLegend';
import React from 'react';

const Legend = ({ type, ...props }) => {
  switch (type) {
    case 'GRADIENT':
      return (
        <GradientLegend
          {...props}
          minValue={props.minValue ?? props.legendMin}
          midValue={props.midValue}
          maxValue={props.maxValue ?? props.legendMax}
        />
      );
    case 'EVENTLEGEND':
      return <EventLegend />
    default:
      return null;
  }
};

export default Legend;
